import React from 'react';

const TeacherForm = ({ user }) => {

    return (
        <div>
            <h1>form t</h1>
            <button>Sub</button>
        </div>
    );
};

export default TeacherForm;